import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2';
import { SonForm } from '../../../_lib/Form2';

type PrivilegedGroupsDeleteFormProps = {
  form: SonForm<any>;
  refresh: () => void;
};

export function PrivilegedGroupsDeleteForm({ form, refresh }: PrivilegedGroupsDeleteFormProps) {
  const { t } = useSonTranslation('PrivilegedGroups');

  return (
    <AcceptDeclineForm
      messageSuccess={t('phrases.delete.success')}
      messageSending={t('phrases.delete.sending')}
      messageFail={t('phrases.delete.fail')}
      headline={t('phrases.delete.question')}
      form={form}
      onSuccess={refresh}
    />
  );
}
